import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';

export type RowError = {
  row: number;
  issues: string[];
};

interface Props {
  open: boolean;
  onClose: () => void;
  errors: RowError[];
  onUploadNewFile: () => void;
}

export default function VerifyImportModal({ open, onClose, errors, onUploadNewFile }: Props) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <WarningAmberIcon color="warning" />
          <Typography variant="h6">
            Import Failed: {errors.length} row
            {errors.length !== 1 ? 's' : ''} have errors
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell width={80}>Row #</TableCell>
              <TableCell>Issues</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {_.map(errors, ({ row, issues }) => (
              <TableRow key={row}>
                <TableCell>{row}</TableCell>
                <TableCell>
                  <Box component="ul" sx={{ m: 0, pl: 2 }}>
                    {_.map(issues, (issue, i) => (
                      <li key={i}>
                        <Typography variant="body2">{issue}</Typography>
                      </li>
                    ))}
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button variant="contained" onClick={onUploadNewFile}>
          Upload New File
        </Button>
      </DialogActions>
    </Dialog>
  );
}
